// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a6387b27","455":"2b6ca2af","946":"a4e0e3d7"}[chunkId] + ".chunk.js";
};